import React from 'react';

import TypeContext from '~/src/components/context/TypeContext';
import Link from '~/src/components/link/Link';
import ActionBubble from '~/src/components/actionBubble/ActionBubble';
import TeaserAction from '~/src/components/teaser/teaserAction/TeaserAction';
import Quote from '~/src/components/quote/Quote';

import {TeaserTypes} from '~/src/utilities/constants/types';
import {ActionBubbleFormat} from '~/src/utilities/constants/formats';
import {getContentUrl} from '~/src/utilities/helpers/link';
import {classNames, getFormatClassNames} from '~/src/utilities/helpers/css';

import css from './LifestyleQuoteTeaser.module.scss';

interface LifestyleQuoteTeaserProps {
    type: string;
    id: number;
    url: string;
    quote: {
        quote: string;
        author?: string;
    };
    format: {
        primaryGrid: string;
        secondaryGrid: string;
        colorScheme: string;
    };
    community: {
        shares: number;
        comments: number;
        contentRatings: number;
    };
    settings: {
        commentingEnabled: boolean;
        sharingEnabled: boolean;
    };
}

const LifestyleQuoteTeaser = ({id, url, quote, format, community, settings}: LifestyleQuoteTeaserProps) => {
    const className = classNames(css, 'teaser', getFormatClassNames(format));

    return (
        <TypeContext value={TeaserTypes.ARTICLES}>
            <Link className={className} href={getContentUrl(url)}>
                <Quote {...quote} format={format} />
            </Link>
            <footer className={css.footer}>
                <TeaserAction {...community} id={id.toString()} settings={settings} showNumbers={true} format={format} />
                <ActionBubble metadataId={id.toString()} format={ActionBubbleFormat.ACTION_BUBBLE_TEASER} teaserFormat={format} settings={settings} />
            </footer>
        </TypeContext>
    );
};

export default LifestyleQuoteTeaser;
